var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYahoo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 264.583 73.375",
    id: "svg8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(260.955 41.214)",
    fill: "#5f01d1",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 0.088,
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeDasharray: "none",
    strokeOpacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-260.955-23.352h15.74l9.166 23.45 9.285-23.45h15.326l-23.078 55.514h-15.423l6.317-14.71z",
    id: "path1139",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-195.471-24.285c-11.827 0-19.304 10.607-19.304 21.17 0 11.886 8.197 21.31 19.08 21.31 8.117 0 11.177-4.946 11.177-4.946V17.1h13.73V-23.35h-13.73v3.677s-3.414-4.611-10.953-4.611zm2.92 13c5.457 0 8.273 4.318 8.273 8.214 0 4.196-3.017 8.313-8.273 8.313-4.356 0-8.293-3.56-8.293-8.134 0-4.64 3.166-8.393 8.293-8.393z",
    id: "path1141",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-166.06 17.101v-58.315h14.36v21.68s3.41-4.746 10.554-4.746c8.738 0 13.857 6.51 13.857 15.814V17.1h-14.254V-4.964c0-3.148-1.5-6.19-4.897-6.19-3.458 0-5.26 3.088-5.26 6.19v22.065Z",
    id: "path1145",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-102.805-24.28c-13.545 0-21.61 10.299-21.61 21.333 0 12.557 9.765 21.142 21.66 21.142 11.53 0 21.62-8.195 21.62-20.931 0-13.936-10.564-21.544-21.67-21.544zm.129 13.114c4.784 0 8.094 3.985 8.094 8.234 0 3.624-3.084 8.094-8.094 8.094-4.59 0-8.036-3.682-8.036-8.134 0-4.288 2.864-8.194 8.036-8.194z",
    id: "path1147",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1153",
    d: "M-57.213-24.28c-13.544 0-21.609 10.299-21.609 21.333 0 12.557 9.765 21.142 21.66 21.142 11.53 0 21.619-8.195 21.619-20.931 0-13.936-10.563-21.544-21.67-21.544zm.13 13.114c4.784 0 8.094 3.985 8.094 8.234 0 3.624-3.085 8.094-8.095 8.094-4.59 0-8.035-3.682-8.035-8.134 0-4.288 2.864-8.194 8.035-8.194z",
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path1155",
    cx: -24.212,
    cy: 8.425,
    r: 9.535,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11.543-4.614H-28.71l15.236-36.6H3.628Z",
    id: "path1157",
    opacity: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYahoo);
export default __webpack_public_path__ + "static/media/yahoo.04bad9c6584196eeaefe9e0730dbac53.svg";
export { ForwardRef as ReactComponent };